import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function OutboundDistributions({ outboundDistributions = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        { key: "share_pct", label: "Share (%)" },
        { key: "avg_lead_time_days", label: "Avg. Lead Time (Days)" },
        { key: "export_volume_pct", label: "Export Volume (%)" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        { key: "share_pct", label: "Share (%)" },
        { key: "geographic_reach", label: "Geographic Reach" },
        { key: "avg_lead_time_days", label: "Avg. Lead Time (Days)" },
        { key: "export_volume_pct", label: "Export Volume (%)" },
        { key: "distribution_risk", label: "Distribution Risk" },
        { key: "strategic_significance", label: "Strategic Significance" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(
      outboundDistributions
    );
    setTabData(transformed);

    setTableBelowDescription(
      <ParsedTextWithLinks
        text={outboundDistributions?.[0]?.response?.tableComments || ""}
      />
    );
  }, [outboundDistributions]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Outbound Distributions"
      subtitle=""
      data={tabData}
      metrics={columns}
      rowIdentifier="mode"
      // belowTableDescription={tableBelowDescription}
      belowTableDescription={""}
      actions={actions}
    />
  );
}

export default OutboundDistributions;
